module.exports = __webpack_public_path__ + "media/assets/icons/replicate-363124353f67a281e7ca43722415db78.svg";